import {
    selectDealer,
    setCurrentLatLng,
    setDealerLocatorRenderFlag,
    setDealers,
    setZipCode
} from "../../core/redux/ActionCreator";
import Button from "@material-ui/core/Button";
import React, {useEffect, useState} from "react";
import {CURRENT} from "../../shared/constantsEN";
import {useDispatch, useSelector} from "react-redux";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Snackbar from "@material-ui/core/Snackbar";
import _ from "lodash";

export default function UseCurrentLocationButton(props) {
    const dispatch = useDispatch();

    const [snackPack, setSnackPack] = useState([]);
    const [messageInfo, setMessageInfo] = useState(undefined);
    const [open, setOpen] = useState(false);
    const reduxCurrentLatLng = useSelector(state => state.dealerReducer.currentLatLng);

    const handleClick = () => {
        if (!navigator.geolocation) {
            console.log("Geolocation is not supported by this browser.");
            const message = "Geolocation is not supported by this browser.";
            setSnackPack((prev) => [...prev, {message, key: new Date().getTime()}]);
        } else {
            navigator.geolocation.getCurrentPosition(setCurrentPosition, handleGeolocationError, {
                timeout: 30000,
                enableHighAccuracy: true,
                maximumAge: 75000
            });
        }
    };

    function setCurrentPosition(position) {
        dispatch(setZipCode('empty'));

        if (!_.isEqual(reduxCurrentLatLng, {lat: position.coords.latitude, lng: position.coords.longitude})) {
            dispatch(setCurrentLatLng(position));
            dispatch(setDealers([]));
            dispatch(selectDealer({dealerBAC:''}));
            dispatch(setDealerLocatorRenderFlag(false));
        }

        if (props.handleClick) {
            props.handleClick();
        }
    }

    function handleGeolocationError(error) {
        let message;
        switch (error.code) {
            case error.PERMISSION_DENIED:
                console.log("User denied the request for Geolocation.");
                message = "User denied the request for Geolocation.";
                break;
            case error.POSITION_UNAVAILABLE:
                console.log("Location information is unavailable.");
                message = "Location information is unavailable.";
                break;
            case error.TIMEOUT:
                console.log("The request to get user location timed out.");
                message = "The request to get user location timed out.";
                break;
            case error.UNKNOWN_ERROR:
                console.log("An unknown error occurred.");
                message = "An unknown error occurred.";
                break;
            default:
                console.log(`Error [${error.code}] has occurred.`);
                message = `Error [${error.code}] has occurred.`;
        }
        setSnackPack((prev) => [...prev, {message, key: new Date().getTime()}]);
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    const handleExited = () => {
        setMessageInfo(undefined);
    };

    useEffect(() => {
        if (snackPack.length && !messageInfo) {
            setMessageInfo({...snackPack[0]});
            setSnackPack((prev) => prev.slice(1));
            setOpen(true);
        } else if (snackPack.length && messageInfo && open) {
            setOpen(false);
        }
    }, [snackPack, messageInfo, open]);

    return (
        <>
            <Button className="searchTagLink stat-text-link" data-dtm={props.dataDtm} color="inherit"
                    onClick={() => {
                        handleClick();
                    }}>
                {CURRENT}
            </Button>
            <Snackbar key={messageInfo ? messageInfo.key : undefined}
                      open={open}
                      autoHideDuration={6000}
                      onClose={handleClose}
                      onExited={handleExited}
                      message={messageInfo ? messageInfo.message : undefined}
                      action={
                          <>
                              <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  onClick={handleClose}>
                                  <CloseIcon/>
                              </IconButton>
                          </>
                      }
            />
        </>
    )
}

